module.exports = __webpack_public_path__ + "static/media/online.13fcf8c0.png";